import PropTypes from "prop-types";
import { Button, Modal } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { TourStepBody, TourStepCover } from "./TourStepContent";
import "./productTourHeroModal.css";

const ProductTourHeroModal = ({
    open,
    stepId,
    kicker,
    title,
    description,
    children,
    onDismiss,
    onSkip,
    skipLabel,
    onPrimary,
    primaryLabel,
    primaryDisabled,
    primaryLoading,
    progressCurrent,
    progressTotal,
    showPrimary,
    showSkip,
    showProgress,
    closable,
    maskClosable,
}) => (
    <Modal
        open={open}
        onCancel={onDismiss}
        footer={null}
        closable={closable}
        maskClosable={maskClosable}
        centered
        width={520}
        destroyOnClose
        styles={{ mask: { backgroundColor: "rgba(24, 24, 68, 0.52)" } }}
        style={{ maxWidth: "calc(100vw - 32px)" }}
        className="product-tour-hero-modal"
        wrapClassName="product-tour-hero-modal-wrap">
        <TourStepCover stepId={stepId} kicker={kicker} variant="welcome" />
        <div className="product-tour-hero-modal__header">
            <h2 className="product-tour-hero-modal__title">{title}</h2>
        </div>
        <div className="product-tour-hero-modal__description">
            <TourStepBody description={description} />
        </div>
        {children ? <div className="product-tour-hero-modal__content">{children}</div> : null}
        <div className="product-tour-hero-modal__footer">
            {showProgress && progressTotal > 1 ? (
                <div className="product-tour-progress" aria-hidden={false}>
                    <div className="product-tour-progress-track">
                        <div
                            className="product-tour-progress-fill"
                            style={{ width: `${(progressCurrent / progressTotal) * 100}%` }}
                        />
                    </div>
                    <span className="product-tour-progress-count">
                        {progressCurrent}/{progressTotal}
                    </span>
                </div>
            ) : (
                <span />
            )}
            <div className="product-tour-hero-modal__actions">
                {showSkip && onSkip ? (
                    <Button type="text" size="small" onClick={onSkip}>
                        {skipLabel}
                    </Button>
                ) : null}
                {showPrimary ? (
                    <Button
                        type="primary"
                        size="small"
                        onClick={onPrimary}
                        disabled={primaryDisabled}
                        loading={primaryLoading}
                        className="product-tour-hero-modal__primary">
                        <span className="inline-flex items-center gap-1">
                            {primaryLabel}
                            <ArrowRightOutlined />
                        </span>
                    </Button>
                ) : null}
            </div>
        </div>
    </Modal>
);

ProductTourHeroModal.propTypes = {
    open: PropTypes.bool.isRequired,
    stepId: PropTypes.string.isRequired,
    kicker: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    children: PropTypes.node,
    onDismiss: PropTypes.func,
    onSkip: PropTypes.func,
    skipLabel: PropTypes.string,
    onPrimary: PropTypes.func,
    primaryLabel: PropTypes.string,
    primaryDisabled: PropTypes.bool,
    primaryLoading: PropTypes.bool,
    progressCurrent: PropTypes.number,
    progressTotal: PropTypes.number,
    showPrimary: PropTypes.bool,
    showSkip: PropTypes.bool,
    showProgress: PropTypes.bool,
    closable: PropTypes.bool,
    maskClosable: PropTypes.bool,
};

ProductTourHeroModal.defaultProps = {
    kicker: undefined,
    children: null,
    onDismiss: undefined,
    onSkip: undefined,
    skipLabel: "",
    onPrimary: undefined,
    primaryLabel: "",
    primaryDisabled: false,
    primaryLoading: false,
    showPrimary: false,
    showSkip: false,
    showProgress: false,
    progressCurrent: 1,
    progressTotal: 1,
    closable: true,
    maskClosable: false,
};

export default ProductTourHeroModal;
